<template>
  <div>
    <el-dialog
        title="Publish Track"
        :visible="publish_track"
        width="440px"
        top="40vh"
        :modal="true"
        @close="close"
        :close-on-click-modal="false"
    >
      <div class="flex-center mb20 mt10">
        Choose if the track {{this.track.title }}<br>will have a free or paid campaign
      </div>
      <div slot="footer" class="flex-center">
        <el-button type="info" size="mini" :loading="loading" @click="submit('free')">Free</el-button>
        <el-button type="success" size="mini" :loading="loading" @click="submit('paid')">Paid</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';

export default {
  props: ['page'],

  data() {
    return {
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    };
  },

  computed: {
    ...mapState('trackImport', [
      'loading',
      'track',
      'publish_track',
    ]),
    ...mapState('global', ['preview']),
  },

  methods: {
    ...mapActions('trackImport', [
      'adminPublish'
    ]),
    ...mapMutations('trackImport', ['setPublishTrack']),

    submit(type) {
      this.$confirm(`You will publish this track as ${type}. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
          .then(() => {
            console.log(type)
            this.adminPublish({id: this.track.id,type:type});
            this.setPublishTrack(false)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Publish cancelled',
            });
          });
    },

    close() {
      this.setPublishTrack(false);
    }
  },
};
</script>

<style scoped lang="scss">

label.el-checkbox {
  display: inline-block;
}

.smart-links {
  small {
    margin-left: 10px;
  }
}

.smart-link-input {
  .el-input {
    width: 70%;
    margin-right: 10px;
  }
}
.image {
  &--uploader {
    label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      width: 120px;
      height: 120px;
      border: 1px dashed #d9d9d9;
      cursor: pointer;
    }
  }
  &--preview {
    text-align: center;
    position: relative;

    img{
      object-fit: cover;
    }

    &:hover {
      .overlay {
        display: flex;
        .btn-remove{
          background: red;
          color: white;
          margin-top: unset;
          cursor: pointer;
        }
      }
    }

    .overlay {
      position: absolute;
      z-index: 5;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 100%;
      background: rgba(0, 0, 0, .1);
      display: none;
      align-items: center;
      justify-content: center;
    }
  }
}
.tiktok_data, .shorts_data, .youtube_data, .instagram_data{
  border: 1px solid;
  padding: 20px;
  border-radius: 10px;
  margin: 20px 0;
  .title{
    color:#000;
    text-transform: uppercase;
    border-bottom: 1px solid;
    text-align: center;
    cursor: pointer;
    padding-bottom: 10px;
  }
  .arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
  }
  .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
}
</style>
